import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setDynamicCanonical } from "../../setCanonical";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    setDynamicCanonical();
  }, [pathname]);

  return null;
}
